import { createSlice, current } from '@reduxjs/toolkit';
import {
	getFiscalizerList,
	addNewFiscalizer,
	updateFiscalizer,
	deleteFiscalizer,
} from './thunk';

export const initialState = {
	fiscalizerList: [],
	fiscalizerListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
};

const FiscalizerSlice = createSlice({
	name: 'Fiscalizer',
	initialState,
	reducers: {},
	extraReducers: builder => {
		builder.addCase(getFiscalizerList.pending, state => {
			state.isLoadingList = true;
		});

		builder.addCase(getFiscalizerList.fulfilled, (state, action) => {
			const list = action.payload || [];
			state.fiscalizerList = list;
			state.fiscalizerListSelect = list.map(item => ({
				item,
				value: item._id,
				label: item.name || '',
			}));
			state.isLoadingList = false;
		});

		builder.addCase(getFiscalizerList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
		});

		builder.addCase(addNewFiscalizer.pending, state => {
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});

		builder.addCase(addNewFiscalizer.fulfilled, (state, action) => {
			state.fiscalizerList.unshift(action.payload);
			state.fiscalizerListSelect.unshift({
				item: action.payload,
				value: action.payload._id,
				label: action.payload.name || '',
			});
			state.isAdding = false;
			state.isAdded = true;
		});

		builder.addCase(addNewFiscalizer.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isAdding = false;
			state.isAddError = true;
		});

		builder.addCase(updateFiscalizer.pending, state => {
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});

		builder.addCase(updateFiscalizer.fulfilled, (state, action) => {
			state.fiscalizerList = state.fiscalizerList.map(item =>
				item._id.toString() === action.payload._id.toString()
					? { ...item, ...action.payload }
					: item
			);
			state.fiscalizerListSelect = state.fiscalizerList.map(item => ({
				item,
				value: item._id,
				label: item.name || '',
			}));
			state.isUpdating = false;
			state.isUpdated = true;
		});

		builder.addCase(updateFiscalizer.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isUpdating = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteFiscalizer.pending, state => {
			state.isDeleting = true;
			state.isDeleted = false;
			state.isDeleteError = false;
		});

		builder.addCase(deleteFiscalizer.fulfilled, (state, action) => {
			state.fiscalizerList = current(state.fiscalizerList).filter(
				item => item._id !== action.payload._id
			);
			state.fiscalizerListSelect = state.fiscalizerList.map(item => ({
				item,
				value: item._id,
				label: item.name || '',
			}));
			state.isDeleting = false;
			state.isDeleted = true;
		});

		builder.addCase(deleteFiscalizer.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isDeleting = false;
			state.isDeleteError = true;
		});
	},
});

export default FiscalizerSlice.reducer;
